import React, {Component, PropTypes} from 'react'
import {Input, Button} from 'react-bootstrap'
import Icon from './Icon'
import style from './MultiInput.less'

class MultiInput extends Component {
    static propTypes = {
        labelClassName: PropTypes.string,
        wrapperClassName: PropTypes.string,
        inverse: PropTypes.bool,
        value: PropTypes.any,
        onChange: PropTypes.func.isRequired
    }

    _add(event) {
        const {value, onChange} = this.props

        event.preventDefault()

        const arrayValue = value || []
        const nextArrayValue = [null, ...arrayValue]

        onChange(nextArrayValue)
    }

    _remove(event, index) {
        const {value, onChange} = this.props

        event.preventDefault()

        const arrayValue = value || []
        var nextArrayValue = [...arrayValue]
        nextArrayValue.splice(index, 1)

        onChange(nextArrayValue)
    }

    _change(event) {
        const {value, onChange} = this.props

        const nextValue = event.target.value

        const arrayValue = value || []
        var nextArrayValue = [...arrayValue]

        nextArrayValue[0] = nextValue || null
        if (nextArrayValue.length == 1 && !nextArrayValue[0]) {
            // reset array
            nextArrayValue = []
        }

        onChange(nextArrayValue)
    }

    render() {
        const {labelClassName, wrapperClassName, value, onChange, inverse, bsStyle, ...others} = this.props

        const buttonAfter = (index) => {
            if (value && value.length > 1) {
                return (
                    <Button
                        onClick={(e) => this._remove(e, index)}>
                        <Icon icon='minus' size='xs' />
                    </Button>
                )
            }
        }

        const input = (
            <Input
                labelClassName={labelClassName}
                wrapperClassName={wrapperClassName}
                buttonAfter={buttonAfter()}
                onChange={(e) => this._change(e)}
                value={value && value[0] || ''} // fix uncontrolled input issue
                bsStyle={bsStyle}
                {...others} />
        )

        const disabledInput = (item, index) => (
            <Input disabled
                key={index}
                labelClassName={labelClassName}
                wrapperClassName={wrapperClassName}
                type='text'
                label=' '
                buttonAfter={buttonAfter(index + 1)}
                value={item} />
        )

        return (
            <div>
                {!inverse && (
                    <div>
                        {input}
                        {value && value.slice(1).map(disabledInput)}
                    </div>
                )}
                {!!inverse && (
                    <div>
                        {value && value.slice(1).reverse().map(disabledInput)}
                        {input}
                    </div>
                )}
                {value && value.length > 0 && !bsStyle && (
                    <div>
                        <div className={labelClassName} />
                        <div className={wrapperClassName}>
                            <div className={style.add}>
                                <a
                                    href=''
                                    onClick={(e) => this._add(e)}>
                                    <Icon icon='plus' size='xs' />
                                    <span>ajouter</span>
                                </a>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default MultiInput


// WEBPACK FOOTER //
// ./lib/core/components/MultiInput.js